import { screenSizeDetection as c, useGlobalStore as f, pageUtils as i } from "@sunrise/shared";
import { defineComponent as g, reactive as p } from "vue";
import { getLoginLink as d } from "./index569.js";
import M from "./index147.js";
import h from "./index164.js";
import B from "./index165.js";
import b from "./index166.js";
import L from "./index167.js";
import H from "./index168.js";
import R from "./index169.js";
import O from "./index182.js";
import w from "./index184.js";
const z = g({
  name: "MsHeader",
  components: {
    MsBurgerMenuBtn: M,
    MsHeaderBookmark: h,
    MsHeaderLinks: B,
    MsHeaderLogin: b,
    MsHeaderLogo: L,
    MsHeaderRelocation: H,
    MsHeaderRelocationToggle: R,
    MsNavBar: O,
    MsOffcanvasNav: w
  },
  props: {
    cmsContent: {
      type: Object,
      required: !0
    },
    isRelocationEnabled: {
      default: !0,
      type: Boolean
    }
  },
  setup(t) {
    var n;
    const { isScreenL: a } = c(), o = p({
      showRelocation: ((n = r()) == null ? void 0 : n.id) === "deutschland",
      isBurgerMenuOpen: !1
    });
    function s() {
      o.showRelocation = !o.showRelocation;
    }
    function l() {
      o.isBurgerMenuOpen = !o.isBurgerMenuOpen, o.isBurgerMenuOpen ? i.disablePageScroll() : i.enablePageScroll();
    }
    function r() {
      var e;
      return (e = f().requestContext) == null ? void 0 : e.location;
    }
    function m() {
      return t.cmsContent.mainNavigation || u();
    }
    function u() {
      return t.cmsContent.navigations.map((e) => ({
        text: e.channelLabel,
        highlighted: e.highlighted,
        url: e.url,
        nofollow: e.nofollow,
        target: e.target
      }));
    }
    return {
      getLocation: r,
      getMainNavigationItems: m,
      state: o,
      isScreenL: a,
      toggleBurgerMenu: l,
      toggleRelocation: s,
      getLoginLink: d
    };
  }
});
export {
  z as default
};
